import { DirectoryFaxNumberDto } from "@/ContactDirectory/Api/medfar-contactdirectory/dist";
import { DirectoryFaxNumber } from "@/ContactDirectory/Models/DirectoryFaxNumber";

export class DirectoryFaxNumberMapper {
    public static toDto(faxNumber: DirectoryFaxNumber): DirectoryFaxNumberDto {
        return {
            number: faxNumber.number,
            countryId: faxNumber.countryId,
            description: faxNumber.description
        };
    }
}
